/**
 * Created by dimah on 09/08/17.
 */
import { IUserSigned } from '@signature-it/ngx-generic/interfaces';
import { AbstractUserDTO } from './user-abstract';

export abstract class SignedUserDTO extends AbstractUserDTO implements IUserSigned {
    first_name: string;
    last_name: string;
    user_phone: string;
    user_phone2: string;
    username: string;
    user_email: string;
    master_user: number;
    master_username: string;
    manager_user: number;
    manager_username: string;
    user_active: boolean;
    external_address_id: string;
    user_address: string;
    external_account_code: string;
    shipping_address_id: number;
    billing_address_id: number;
    user_contact: string;
    _fullName: string;
    phone_order_mode: boolean;
    is_employee: boolean;
    variety_solr_key: string;
    c_r2: string;
    _aclPermissions: Array<string>;
    distribution_channel: any;
    user_profile: any;
    is_all_permissions: boolean;
    first_login: boolean;
    first_login_step: number;
    user_currency: string;
    industry: string;
    user_company: string;
    user_country: string;
    c_dt: string;
    c_r1: string;
    login_land_page: string;
    c_pt: string;
    acmGroups: [];

    protected constructor(attributes: object) {
        super(attributes);
        attributes = attributes || {};
        Object.assign(this, attributes);

        this.first_name = attributes['first_name'] || '';
        this.last_name = attributes['last_name'] || '';
        this.user_phone = attributes['user_phone'] || '';
        this.user_phone2 = attributes['user_phone2'] || '';
        this.username = attributes['username'] || '';
        this.user_email = attributes['user_email'] || '';
        this.master_user = Number(attributes['master_user']) || 0;
        this.master_username = attributes['master_username'] || '';
        this.manager_user = attributes['manager_user'] || '';
        this.manager_username = attributes['manager_username'] || '';
        this.user_active = attributes['user_active'] == 1 || attributes['user_active'] == true;
        this.external_address_id = attributes['external_address_id'] || '';
        this.user_address = attributes['user_address'] || '';
        this.external_account_code = attributes['external_account_code'] || '';
        this.user_contact = attributes['user_contact'] || '';
        this.shipping_address_id = attributes['shipping_address_id'] || '';
        this.billing_address_id = attributes['billing_address_id'] || '';
        this.full_name = attributes['full_name'] || '';
        this.phone_order_mode = attributes['phone_order_mode'] == true;
        this.is_employee = attributes['is_employee'] == true;
        this.variety_solr_key = attributes['variety_solr_key'] || '';
        this.c_r2 = attributes['c_r2'] || '';
        this.aclPermissions = attributes['acl'] || [];
        this.distribution_channel = attributes['distribution_channel'] || [];
        this.user_profile = attributes['user_profile'] || [];
        this.is_all_permissions = attributes['is_all_permissions'] || false;
        this.first_login = attributes['first_login'] == 1 ? true : false;
        this.first_login_step = attributes['first_login'];
        this.user_currency = attributes['user_currency'] || '';
        this.industry = attributes['industry'] || '';
        this.user_company = attributes['user_company'] || '';
        this.user_country = attributes['user_country'] || '';
        this.c_dt = attributes['c_dt'] || '';
        this.c_r1 = attributes['c_r1'] || '';
        this.login_land_page = attributes['login_land_page'] || '';
        this.c_pt = attributes['c_pt'] || '';
        this.acmGroups = attributes['acmGroups'] || [];
    }

    set full_name(value: string) {
        let name = value || `${this.first_name} ${this.last_name}`;
        this._fullName = name == ' ' ? (this.user_contact || this.username) : name;
    }

    get full_name() {
        return this._fullName;
    }

    set aclPermissions(value: any[]) {
        this._aclPermissions = value.map(a => a.name);
    }

    get aclPermissions() {
        return this._aclPermissions;
    }
}
